export const marketplace = {
  marketplaceSearchInputPlaceholderTitle: 'Rechercher',
  marketplaceDetailsCurtainCopyOptionTitle: 'Copier le lien',
  marketplaceDetailsCurtainFlagOptionTitle: 'Signaler le contenu',
  marketplaceDetailsCurtainCopiedAlertText: 'Lien copié !',
  marketplaceDetailsFlagCurtainTitle: 'Signaler',
  marketplaceReportedCurtainContent: 'Contenu signalé',
  marketplaceAllItems: 'Tous les articles',
  marketplaceWantToBuy: "Envie d'acheter {item} sur {appname}"
}
